<template>
<div>
    <MonitorMenuList v-if="isAdmin || isMonitor" />
    <ManagerMenuList v-else />
</div>
</template>

<script>
import store from "@/store"
import ManagerMenuList from "@/components/home-page/ManagerMenuList"
import MonitorMenuList from "@/components/home-page/MonitorMenuList"

export default {
    name: "home-page",

    components: {
        ManagerMenuList,
        MonitorMenuList
    },

    computed: {
        isAdmin () {
            return store.getters.hasPermissions(["admin"])
        },

        isMonitor () {
            return store.getters.hasPermissions(["monitor"])
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/HomePage.vue